/**
 * 콘솔 이스터에그 유틸리티
 * 개발자 정보 및 시스템 정보를 콘솔에 표시
 */

import { AppEnv } from "@/config/env";

let hasPrinted = false;

export const printDeveloperInfo = () => {
  // StrictMode에서 2번 실행 방지
  if (hasPrinted) return;
  hasPrinted = true;

  // JUNGI (ASCII Art)
  console.log(
    "%c" +
      "      ██╗██╗   ██╗███╗   ██╗ ██████╗ ██╗\n" +
      "      ██║██║   ██║████╗  ██║██╔════╝ ██║\n" +
      "      ██║██║   ██║██╔██╗ ██║██║  ███╗██║\n" +
      " ██   ██║██║   ██║██║╚██╗██║██║   ██║██║\n" +
      " ╚█████╔╝╚██████╔╝██║ ╚████║╚██████╔╝██║\n" +
      "  ╚════╝  ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝ ╚═╝",
    "color: #667eea; font-size: 10px; font-weight: bold;"
  );

  // SONG (ASCII Art)
  console.log(
    "%c" +
      " ███████╗ ██████╗ ███╗   ██╗ ██████╗ \n" +
      " ██╔════╝██╔═══██╗████╗  ██║██╔════╝ \n" +
      " ███████╗██║   ██║██╔██╗ ██║██║  ███╗\n" +
      " ╚════██║██║   ██║██║╚██╗██║██║   ██║\n" +
      " ███████║╚██████╔╝██║ ╚████║╚██████╔╝\n" +
      " ╚══════╝ ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝ ",
    "color: #f093fb; font-size: 10px; font-weight: bold;"
  );

  // 시스템 타이틀
  console.log(
    "%c               🚛 LOGISTICS ERP SYSTEM 🚛",
    "color: #f093fb; font-size: 14px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.3);"
  );

  // 정보 박스
  console.log("%c┌─────────────────────────────────────────────────────────────┐", "color: #4facfe;");
  console.log("%c│                                                             │", "color: #4facfe;");
  console.log(
    "%c│    👨‍💻 Developer: %c송준기 (Song Jungi)%c                       │",
    "color: #4facfe;",
    "color: #f5af19; font-weight: bold; font-size: 13px;",
    "color: #4facfe;"
  );
  console.log(
    "%c│    📦 Version: %c1.0.0%c                                        │",
    "color: #4facfe;",
    "color: #00f2fe; font-weight: bold;",
    "color: #4facfe;"
  );
  console.log(
    "%c│    📅 Built: %c2025%c                                           │",
    "color: #4facfe;",
    "color: #43e97b; font-weight: bold;",
    "color: #4facfe;"
  );
  console.log("%c│                                                             │", "color: #4facfe;");
  console.log("%c└─────────────────────────────────────────────────────────────┘", "color: #4facfe;");

  // 기술 스택
  console.log(
    "%c         ⚡ Powered by React + TypeScript + Spring Boot ⚡",
    "color: #fa709a; font-size: 11px; font-style: italic;"
  );

  // 환경변수 정보
  console.log("");
  console.log("%c📋 Environment", "color: #9ca3af; font-weight: bold; font-size: 12px;");
  console.log("%c   API_URL: %c" + AppEnv.API_URL, "color: #9ca3af;", "color: #60a5fa;");
  console.log("%c   MODE: %c" + AppEnv.MODE, "color: #9ca3af;", "color: #34d399;");
  console.log(
    "%c   IS_DEV: %c" + AppEnv.IS_DEV + "%c | IS_PROD: %c" + AppEnv.IS_PROD,
    "color: #9ca3af;",
    AppEnv.IS_DEV ? "color: #fbbf24;" : "color: #6b7280;",
    "color: #9ca3af;",
    AppEnv.IS_PROD ? "color: #f87171;" : "color: #6b7280;"
  );
};
